import React from "react";
import "./About.css";
import { about } from "../../assets/";
import { keypoints } from "../../data";

const About = () => {
  return (
    <section id="about">
      <div className="overlay__div">
        <div className="container">
          <div className="about__image">
            <img src={about} alt="" />
          </div>
          <div className="section__header">
            <h3 className="title" id="aboutTitle">About Us</h3>
            <h1 id="aboutHeading" className="sub__heading">
              Building Excellence, Shaping the Future Since 1985
            </h1>
            <p className="description">
              Since 1985, Ashfaq Builders has been delivering high-quality
              residential, commercial, and industrial construction with a
              commitment to excellence. Backed by over 40 years of experience,
              we combine innovative design, skilled craftsmanship, and reliable
              project execution to create spaces that are built to last and
              exceed client expectations.
            </p>
            <div className="keypoints__container">
              {keypoints.map((keypoint, index) => (
                <div className="flex keypoint" key={index}>
                  <div className="flex__center primary icon">
                    {keypoint.icon}
                  </div>
                  <h4 className="title ">{keypoint.title}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
